import styled from 'styled-components';
import { getMediaQuery } from '@carvana/showroom-theme';

export const Section = styled.div`
  background: ${(props) =>
    props.color || props.primary ? props.theme.color.neutral.v200 : props.theme.color.neutral.v100};
  min-height: 30rem;
  color: ${(props) =>
    props.color || props.primary ? props.theme.color.primary.v600 : props.theme.color.neutral.v500};
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  justify-items: center;
  padding-top: 2rem;

  ${(props) => getMediaQuery(props.theme.breakpoint.md)} {
    padding-top: 4.875rem;
  }
`;

export const InnerSection = styled.div`
  padding: 3rem 0 4rem;
  margin: 0 auto;
  max-width: 1440px;
  width: 93%;

  ${(props) => getMediaQuery(props.theme.breakpoint.sm)} {
    width: 91%;
  }

  ${(props) => getMediaQuery(props.theme.breakpoint.lg)} {
    width: 80%;
    /* padding-left: 2rem;
    padding-right: 2rem; */
  }

  ${(props) => getMediaQuery(props.theme.breakpoint.xl)} {
    width: 1440px;
    padding-left: 12rem;
    padding-right: 12rem;
  }
`;
